import styled from 'styled-components';

export const MetricContent = styled.div`
  padding: 21px 0;
  height: 100%;
  width: 100%;
`;
